export const GROWTH_BOOK = {
  FEATURES: {
    CHECKOUT_LIFE_TIME_PLAN: 'checkout_life_time_plan',
    CHECKOUT_AUTO_RENEW_DISCLAIMER_COUNTRIES:
      'checkout-auto-renew-disclaimer-counties',
    SHOW_LIMITED_TIME_DISCOUNT: 'show-limited-time-discount',
    INIT_BRAZE: 'init_braze_webapp',
    CHECKOUT_PRICING: 'checkOutPricing',
    SHOW_PAYWALL_IN_MODAL: 'showPaywallInModal',
    OPTIN_NEW_ONBOARDING_SCREEN: 'optin-new-onboarding-screen',
    OPTIN_RECONSENT: 'optin-reconsent',
    OPTIN_RECONSENT_BANNER_COLOR: 'optin-reconsent-banner-color',
    OPTIN_TERMS_UPDATED_MODAL: 'optin-terms-updated-modal',
    OPTIN_CONSENT_VARIANT: 'optin-consent-variant',
    OPT_IN_FIRST_ONBOARDING: 'optInFirstOnboarding',
  },
  ATTRIBUTES: {
    COUNTRY: 'country',
  },
  EXPERIMENT_NAMES: {
    CONTROL: 'control',
    TEST: 'test',
  },
  EXTENSION_EXPERIMENTS: {
    USE_LEGACY_ONBOARDING: 'use_legacy_onboarding',
    USE_LEGACY_BLOCKED_PAGE: 'use_legacy_blocked_page',
    DISPLAY_FREEMIUM_CATEGORY_ON_INSTALL: 'displayFreemiumCategoryOnInstall',
  },
};
